import Vue from 'vue';
import Main from './main.vue';

let _isFun = (data) => {
  return Object.prototype.toString.call(data) === '[object Function]';
};

let DialogConstructor = Vue.extend(Main);

const Dialog = (dialogConfig = {}) => {
  if (Vue.prototype.$isServer) return;

  let instance;
  instance = new DialogConstructor({
    el: document.createElement('div'),
  });

  let $body = document.body;
  $body && $body.appendChild(instance.$el);

  instance.id = dialogConfig.id || new Date().getTime();

  instance.width = dialogConfig.width || null;

  instance.height = dialogConfig.height || null;

  instance.dialogConfig.full = null;
  if (dialogConfig.full && dialogConfig.full.class) {
    instance.dialogConfig.full = {
      class: dialogConfig.full.class,
    };
  }
  if (dialogConfig.full && dialogConfig.full.img) {
    if (instance.dialogConfig.full == null) {
      instance.dialogConfig.full = {
        img: dialogConfig.full.img || null,
      };
    } else {
      instance.dialogConfig.full.img = dialogConfig.full.img || null;
    }
  }
  if (dialogConfig.full && dialogConfig.full.callback) {
    if (instance.dialogConfig.full.img) {
      instance.dialogConfig.full.callback = _isFun(dialogConfig.full.callback)
        ? dialogConfig.full.callback
        : () => {};
    }
  }
  instance.dialogConfig.icon = dialogConfig.icon || null;

  instance.dialogConfig.title = dialogConfig.title || null;

  instance.dialogConfig.subTitle = dialogConfig.subTitle || null;

  instance.dialogConfig.text = dialogConfig.text || null;

  instance.dialogConfig.html = dialogConfig.html || null;

  instance.dialogConfig.slot = dialogConfig.slot || null;

  instance.dialogConfig.slotData = dialogConfig.slotData || null;

  instance.dialogConfig.buttonBorder =
    dialogConfig.buttonBorder === undefined ? true : dialogConfig.buttonBorder;

  instance.dialogConfig.closedImg = dialogConfig.closedImg || null;

  instance.backgroundImage = dialogConfig.backgroundImage || null;

  if (dialogConfig.slot) {
    instance.dialogConfig.html = null;
  }

  // 确定按钮 如需要关闭弹框 let _$d = this.$dialog({}) 在确认的callbac 里 调用 _$d.close()
  let submit = {
    name: '确定',
    style: '',
    callback: () => {
      Vue.nextTick(() => {
        instance.visible = false;
      });
    },
  };
  if (dialogConfig.submit) {
    submit = {
      name: dialogConfig.submit.name || '确定',
      style: dialogConfig.submit.style || '',
      callback: _isFun(dialogConfig.submit.callback) ? dialogConfig.submit.callback : () => {},
    };
    instance.dialogConfig.submit = submit;
  } else if (dialogConfig.submit === null) {
    instance.dialogConfig.submit = null;
  }

  // 取消按钮以及自动关闭功能，配置时候，如不需要自动关闭，return false
  let cancel = null;
  if (dialogConfig.cancel) {
    cancel = {
      name: dialogConfig.cancel.name || '取消',
      style: dialogConfig.cancel.style || '',
      callback: () => {
        let autoClose;
        if (_isFun(dialogConfig.cancel.callback)) {
          autoClose = dialogConfig.cancel.callback();
        }
        autoClose = autoClose === undefined ? true : autoClose;
        if (autoClose) {
          Vue.nextTick(() => {
            instance.animation = false;
            setTimeout(() => {
              instance.visible = false;
            }, 200);
          });
        }
      },
    };
  }
  instance.dialogConfig.cancel = cancel;

  // 关闭图标以及自动关闭功能，配置时候，如不需要自动关闭，return false
  let closeIcon = null;
  if (dialogConfig.closeIcon) {
    closeIcon = {
      class: dialogConfig.closeIcon.class || '',
      callback: () => {
        let autoClose;
        if (_isFun(dialogConfig.closeIcon.callback)) {
          autoClose = dialogConfig.closeIcon.callback();
        }
        autoClose = autoClose === undefined ? true : autoClose;
        if (autoClose) {
          Vue.nextTick(() => {
            instance.animation = false;
            setTimeout(() => {
              instance.visible = false;
            }, 200);
          });
        }
      },
    };
  }
  instance.dialogConfig.closeIcon = closeIcon;

  let bgClose = null;
  if (dialogConfig.bgClose == true) {
    bgClose = {
      class: 'iconfont icon-ayh-toast-error',
      callback: () => {
        Vue.nextTick(() => {
          instance.animation = false;
          setTimeout(() => {
            instance.visible = false;
          }, 200);
        });
      },
    };
  } else if (dialogConfig.bgClose) {
    bgClose = {
      class: dialogConfig.bgClose.class || '',
      callback: () => {
        let autoClose;
        if (_isFun(dialogConfig.bgClose.callback)) {
          autoClose = dialogConfig.bgClose.callback();
        }
        autoClose = autoClose === undefined ? true : autoClose;
        if (autoClose) {
          Vue.nextTick(() => {
            instance.animation = false;
            setTimeout(() => {
              instance.visible = false;
            }, 200);
          });
        }
      },
    };
  }
  instance.dialogConfig.bgClose = bgClose;

  instance.callback = (data) => {
    if (dialogConfig.callback && _isFun(dialogConfig.callback)) {
      dialogConfig.callback(data);
    }
  };
  instance.ready = () => {
    if (dialogConfig.ready && _isFun(dialogConfig.ready)) {
      dialogConfig.ready();
    }
  };

  if (typeof dialogConfig.defShow == 'undefined' || dialogConfig.defShow) {
    Vue.nextTick(() => {
      instance.visible = true;
    });
  }

  instance.delayClose = (number, callback) => {
    let _delay = typeof number === 'number' ? number : 2000;
    setTimeout(() => {
      instance.animation = false;
      setTimeout(() => {
        instance.visible = false;
        instance = null;
        if (_isFun(number)) {
          number();
        }
        if (_isFun(callback)) {
          callback();
        }
      }, 200);
    }, _delay);
    return instance;
  };

  return instance;
};

DialogConstructor.prototype.close = function () {
  this.animation = false;
  setTimeout(() => {
    this.visible = false;
  }, 400);
};

DialogConstructor.prototype.show = function () {
  this.visible = true;
};

export default Dialog;
